import React from 'react'
import { motion, Variants } from 'framer-motion'

const animations: Variants = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0 },
}

// https://www.youtube.com/watch?v=GksAsutVXOA&t=391s
// DIY
// https://dev.to/fazliddin04/react-router-v6-animated-transitions-diy-3e6l

export const FadeInWrapper = ({ children }: React.PropsWithChildren<unknown>): React.ReactElement => {
  // import { Box, Fade, Slide } from '@mui/material'
  // <Slide in direction="left" timeout={1000}>
  //   <Box>
  //     <Fade in timeout={1000}>
  //       <Box>{children}</Box>
  //     </Fade>
  //   </Box>
  // </Slide>

  return (
    <motion.div
      key={location.pathname}
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}
